import { GlobalStore } from '@roc/feature-app-core';
import { flow, makeObservable } from 'mobx';
import { DocumentStore } from '@roc/feature-documents';
import { ResolutionService } from '../services/resolutionService';

export class ResolutionStore {
  globalStore: GlobalStore;
  private resolutionService: ResolutionService;

  constructor(globalStore: GlobalStore) {
    this.globalStore = globalStore;
    this.resolutionService = new ResolutionService();
    makeObservable(this, {
      submitResolution: flow,
    });
  }

  *submitResolution(taskId: number, comment: string, file?: File) {
    try {
      yield this.resolutionService.submitResolution(taskId, comment, file);
    } catch (err) {
      this.globalStore.notificationStore.showErrorNotification({
        message: 'Error while submitting resolution.',
      });
      throw err;
    }
  }
}
